"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    messageBarActionsClassNames: function() {
        return messageBarActionsClassNames;
    },
    useMessageBarActionsStyles_unstable: function() {
        return useMessageBarActionsStyles_unstable;
    }
});
const _react = require("@griffel/react");
const messageBarActionsClassNames = {
    root: 'fui-MessageBarActions',
    containerAction: 'fui-MessageBarActions__containerAction'
};
/**
 * Styles for the root slot
 */ const useRootBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1qydg9p", "r1to27xx", [
    ".r1qydg9p{grid-row-start:secondaryActions;grid-column-start:secondaryActions;grid-row-end:secondaryActions;grid-column-end:secondaryActions;display:flex;column-gap:var(--spacingHorizontalM);padding-right:var(--spacingHorizontalM);}",
    ".r1to27xx{grid-row-start:secondaryActions;grid-column-start:secondaryActions;grid-row-end:secondaryActions;grid-column-end:secondaryActions;display:flex;column-gap:var(--spacingHorizontalM);padding-left:var(--spacingHorizontalM);}"
]);
const useContainerActionBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1y6i9ar", "rc0rof2", [
    ".r1y6i9ar{grid-row-start:actions;grid-column-start:actions;grid-row-end:actions;grid-column-end:actions;padding-right:var(--spacingHorizontalM);}",
    ".rc0rof2{grid-row-start:actions;grid-column-start:actions;grid-row-end:actions;grid-column-end:actions;padding-left:var(--spacingHorizontalM);}"
]);
const useMultilineStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Brf1p80: "f1e8xxv9",
        B6of3ja: "f1gaxbfw",
        jrapky: "fqcjy3b",
        t21cq0: [
            "fibjyge",
            "f9yszdx"
        ],
        z189sj: [
            "f1p3vkop",
            "f8cewkv"
        ]
    }
}, {
    d: [
        ".f1e8xxv9{justify-content:end;}",
        ".f1gaxbfw{margin-top:var(--spacingVerticalMNudge);}",
        ".fqcjy3b{margin-bottom:var(--spacingVerticalS);}",
        ".fibjyge{margin-right:0px;}",
        ".f9yszdx{margin-left:0px;}",
        ".f1p3vkop{padding-right:var(--spacingVerticalM);}",
        ".f8cewkv{padding-left:var(--spacingVerticalM);}"
    ]
});
const useMessageBarActionsStyles_unstable = (state)=>{
    const rootBaseStyles = useRootBaseStyles();
    const containerActionBaseStyles = useContainerActionBaseStyles();
    const multilineStyles = useMultilineStyles();
    state.root.className = (0, _react.mergeClasses)(messageBarActionsClassNames.root, rootBaseStyles, state.layout === 'multiline' && multilineStyles.root, state.root.className);
    if (state.containerAction) {
        state.containerAction.className = (0, _react.mergeClasses)(messageBarActionsClassNames.containerAction, containerActionBaseStyles, state.containerAction.className);
    }
    return state;
}; //# sourceMappingURL=useMessageBarActionsStyles.styles.js.map
